import axios from 'axios';

const API_URL = window.location.origin

const apiClient = axios.create({
  baseURL: API_URL,
  timeout: 180000
});

const token = localStorage.getItem('apiToken');
if (token) apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;

export default {
  get(endpoint, config) {
    return apiClient.get(endpoint, config);
  },
  post(endpoint, data) {
    return apiClient.post(endpoint, data, { headers: this.getHeaders() });
  },
  put(endpoint, data) {
    return apiClient.put(endpoint, data, { headers: this.getHeaders() });
  },
  delete(endpoint) {
    return apiClient.delete(endpoint, { headers: this.getHeaders() });
  },
  patch(endpoint, data = {}) {
    return apiClient.patch(endpoint, data, { headers: this.getHeaders() });
  },
  getHeaders() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    const headers = { 'Content-Type': 'application/json' };
    if (csrfToken) {
      headers['X-CSRF-Token'] = csrfToken;
    }
    return headers;
  }
};
